import {
  getAssetMergeParamCount,
  type AssetMergeCandidate,
} from './asset-merge-selection';

export type SuggestAssetMergeSurvivorResult =
  | { status: 'existing'; id: string }
  | { status: 'none' };

export function suggestAssetMergeSurvivor({
  assets,
}: {
  assets: readonly AssetMergeCandidate[];
}): SuggestAssetMergeSurvivorResult {
  if (assets.length < 2) {
    return { status: 'none' };
  }

  const scored = assets.map((asset) => ({
    id: asset.id,
    score: getAssetMergeParamCount(asset),
  }));
  const maxScore = Math.max(...scored.map((entry) => entry.score));
  const winners = scored.filter((entry) => entry.score === maxScore);

  if (winners.length !== 1 || winners[0] === undefined) {
    return { status: 'none' };
  }

  return { status: 'existing', id: winners[0].id };
}
